var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"border-left-green text-transform-none"},[_c('h3',{staticClass:"display-1"},[_c('router-link',{staticClass:"link",attrs:{"to":{ name: 'productPage', params: { slug: _vm.product.slug } },"title":_vm.productDisplayName}},[_vm._v(_vm._s(_vm.productDisplayName))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }